import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {AuthService} from '@/app/core/services/auth.service';

export const guestGuard: CanActivateFn = (_, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const parsed = router.parseUrl(state.url);
  const primarySegments =
    parsed.root.children['primary']?.segments.map((segment) => segment.path) ??
    [];
  const isResetPasswordRoute =
    (primarySegments[0] === 'auth' &&
      primarySegments[1] === 'reset-password' &&
      primarySegments.length >= 3) ||
    (primarySegments[0] === 'lp' &&
      primarySegments[2] === 'auth' &&
      primarySegments[3] === 'reset-password' &&
      primarySegments.length >= 5);

  if (state.url.startsWith('/lp/') || isResetPasswordRoute) {
    return true;
  }
  if (auth.isLoggedIn()) {
    const returnUrl = parsed.queryParams['returnUrl'] ?? '/home';
    router.navigateByUrl(returnUrl);
    return false;
  }
  return true;
};
